import { Label } from '../../Label'

import * as styles from './EntityProfileHeaderLabelList.module.css'

function EntityProfileHeaderLabelList({
  className = styles.EntityProfileHeaderLabelList,
  items,
}) {
  return (
    <div className={className}>
      {items.map(item => (
        <Label {...item} key={item.id} />
      ))}
    </div>
  )
}

export default EntityProfileHeaderLabelList
